import type { PickleballGameListItem, PickleballSessionListItem } from '@/services/pickleballService';

export interface FlatPickleballGame {
  game: PickleballGameListItem;
  sessionSlug: string;
  sessionType: string;
  playerFormat: string;
  gameNumber: number;
}

export function flattenPickleballGames(sessions: PickleballSessionListItem[]): FlatPickleballGame[] {
  const result: FlatPickleballGame[] = [];
  let gameNumber = 1;

  for (const session of sessions) {
    for (const game of session.games ?? []) {
      result.push({
        game: {
          ...game,
          sessionSlug: game.sessionSlug || session.slug,
          sessionType: game.sessionType || session.sessionType,
          playerFormat: game.playerFormat || session.playerFormat,
          scoringType: game.scoringType || session.scoringType,
          rotationFormat: game.rotationFormat || session.rotationFormat,
        },
        sessionSlug: session.slug,
        sessionType: session.sessionType,
        playerFormat: session.playerFormat,
        gameNumber: gameNumber++,
      });
    }
  }

  return result;
}

export function countPlayerAppearances(
  sessions: PickleballSessionListItem[],
  participantId: number
): number {
  let count = 0;
  for (const session of sessions) {
    for (const game of session.games ?? []) {
      const players = [...(game.sideAPlayers ?? []), ...(game.sideBPlayers ?? [])];
      if (players.some((p) => p.participantId === participantId)) {
        count += 1;
      }
    }
  }
  return count;
}
